


// import React, { useState, useEffect } from 'react';
// import { Pie, Line,Bar } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   LineElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   BarElement,
//   Tooltip,
//   Legend,
//   Title,
// } from 'chart.js';
// import { ShoppingBag, Percent, Box } from 'lucide-react';
// import AdminHome from './AdminHome'

// ChartJS.register(
//   ArcElement,
//   LineElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   BarElement,
//   Tooltip,
//   Legend,
//   Title
// );

// const Dashboard = () => {
//   const [activeView, setActiveView] = useState('product');
//   const [products, setProducts] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedStatuses, setSelectedStatuses] = useState(["shipped"]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [productsResponse, ordersResponse] = await Promise.all([
//           fetch('/api/all/products'),
//           fetch('/api/orders')
//         ]);
        
//         const productsData = await productsResponse.json();
//         const ordersData = await ordersResponse.json();
        
//         setProducts(productsData);
//         setOrders(ordersData);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Product Dashboard Calculations
//   const totalProducts = products.length;
//   const totalInventory = products.reduce((sum, product) =>
//     sum + product.size.reduce((acc, size) => acc + size.quantity, 0), 0);
//   const averageDiscount = (products.reduce((sum, product) => sum + product.discount, 0) / totalProducts).toFixed(2);

//   // Size distribution data
//   const sizeCounts = products.flatMap(product => product.size)
//     .reduce((acc, size) => {
//       acc[size.size] = (acc[size.size] || 0) + size.quantity;
//       return acc;
//     }, {});

//   const sizeChartData = {
//     labels: Object.keys(sizeCounts),
//     datasets: [{
//       data: Object.values(sizeCounts),
//       backgroundColor: [
//         '#FF6384',
//         '#36A2EB',
//         '#FFCE56',
//         '#4BC0C0',
//         '#9966FF',
//         '#FF9F40'
//       ]
//     }]
//   };

//   // Price range data
//   const priceRanges = [
//     { range: '₹0-₹5000', count: products.filter(p => p.salePrice < 5000).length },
//     { range: '₹5000-₹10000', count: products.filter(p => p.salePrice >= 5000 && p.salePrice < 10000).length },
//     { range: '₹10000+', count: products.filter(p => p.salePrice >= 10000).length }
//   ];

//   const priceChartData = {
//     labels: priceRanges.map(p => p.range),
//     datasets: [{
//       label: 'Number of Products',
//       data: priceRanges.map(p => p.count),
//       borderColor: 'rgba(75, 192, 192, 1)',
//       backgroundColor: 'rgba(75, 192, 192, 0.3)',
//       pointBackgroundColor: 'rgba(75, 192, 192, 1)',
//       pointBorderColor: 'rgba(75, 192, 192, 1)',
//       borderWidth: 2,
//       tension: 0.4
//     }]
//   };

//   // Orders Dashboard Functions
//   const handleCheckboxChange = (status) => {
//     setSelectedStatuses((prev) =>
//       prev.includes(status)
//         ? prev.filter((item) => item !== status)
//         : [...prev, status]
//     );
//   };

//   const filteredData = selectedStatuses.map((status) => {
//     const count = orders.filter((order) => order.deliveryStatus === status).length;
//     return { status, count };
//   });

//   const orderGraphData = {
//     labels: filteredData.map((item) => item.status),
//     datasets: [
//       {
//         label: "Orders by Status",
//         data: filteredData.map((item) => item.count),
//         borderColor: "#4CAF50",
//         backgroundColor: "rgba(76, 175, 80, 0.2)",
//         fill: true,
//         tension: 0.4,
//       },
//     ],
//   };

//   if (loading) {
//     return <div className="p-4">Loading...</div>;
//   }

//   const ProductView = () => (
//     // <div style={{ display: 'flex', gap: '20px' }}>
//     //   {/* Left side - Stats */}
//     //   <div style={{ width: '30%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
//     //     Total Products Card
//     //     <div className="bg-white p-5 rounded-lg shadow">
//     //       <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
//     //         <ShoppingBag size={24} color="#3b82f6" />
//     //         <div>
//     //           <p className="text-gray-500">Total Products</p>
//     //           <h3 className="text-2xl font-bold mt-1">{totalProducts}</h3>
//     //         </div>
//     //       </div>
//     //     </div>

//     //     Total Inventory Card
//     //     <div className="bg-white p-5 rounded-lg shadow">
//     //       <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
//     //         <Box size={24} color="#10b981" />
//     //         <div>
//     //           <p className="text-gray-500">Total Inventory</p>
//     //           <h3 className="text-2xl font-bold mt-1">{totalInventory}</h3>
//     //         </div>
//     //       </div>
//     //     </div>

//     //     Average Discount Card
//     //     <div className="bg-white p-5 rounded-lg shadow">
//     //       <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
//     //         <Percent size={24} color="#8b5cf6" />
//     //         <div>
//     //           <p className="text-gray-500">Avg. Discount</p>
//     //           <h3 className="text-2xl font-bold mt-1">{averageDiscount}%</h3>
//     //         </div>
//     //       </div>
//     //     </div>
//     //   </div>
      

//     //   {/* Right side - Charts */}
//     //   <div style={{ width: '70%' }}>
//     //     <div className="bg-white p-5 rounded-lg shadow mb-5">
//     //       <h2 className="text-xl font-bold mb-4">Size Distribution</h2>
//     //       <div style={{ height: '300px' }}>
//     //         <Pie
//     //           data={sizeChartData}
//     //           options={{
//     //             responsive: true,
//     //             maintainAspectRatio: false,
//     //             plugins: {
//     //               legend: {
//     //                 position: 'right',
//     //                 labels: { font: { size: 12 } }
//     //               }
//     //             }
//     //           }}
//     //         />
//     //       </div>
//     //     </div>

//     //     <div className="bg-white p-5 rounded-lg shadow">
//     //       <h2 className="text-xl font-bold mb-4">Price Range Distribution</h2>
//     //       <div style={{ height: '300px' }}>
//     //         <Line
//     //           data={priceChartData}
//     //           options={{
//     //             responsive: true,
//     //             maintainAspectRatio: false,
//     //             plugins: {
//     //               legend: { position: 'top' },
//     //               tooltip: {
//     //                 backgroundColor: 'rgba(0,0,0,0.7)',
//     //                 titleColor: 'white',
//     //                 bodyColor: 'white'
//     //               }
//     //             },
//     //             scales: {
//     //               y: {
//     //                 beginAtZero: true,
//     //                 title: {
//     //                   display: true,
//     //                   text: 'Number of Products'
//     //                 }
//     //               },
//     //               x: {
//     //                 title: {
//     //                   display: true,
//     //                   text: 'Price Ranges'
//     //                 }
//     //               }
//     //             }
//     //           }}
//     //         />
//     //       </div>
//     //     </div>
//     //   </div>
//     // </div>
//     <div className="flex flex-col gap-6">
//   <div style={{
//   display: 'flex',
//   flexDirection: 'row',
//   justifyContent: 'space-between',
//   width: '100%'
// }}>
//   {/* Total Products Card */}
//   <div style={{
//     flex: 1,
//     backgroundColor: 'lightyellow',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     marginRight: '15px'
//   }}>
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: '15px'
//     }}>
//       <ShoppingBag size={24} color="#3b82f6" />
//       <div>
//         <p style={{ color: 'black',fontSize:'24px',fontWeight: 'bold', marginBottom: '5px' }}>Total Products</p>
//         <h3 style={{ 
//           fontSize: '34px', 
//           fontWeight: 'bold',
//           marginTop: '5px'
//         }}>{totalProducts}</h3>
//       </div>
//     </div>
//   </div>
//   <div style={{
//     flex: 1,
//     backgroundColor: 'lightgreen',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     marginRight: '15px'
//   }}>
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: '15px'
//     }}>
//       <ShoppingBag size={24} color="#3b82f6" />
//       <div>
//         <p style={{ color: 'black',fontSize:'24px',fontWeight: 'bold', marginBottom: '5px' }}>Total Category</p>
//         <h3 style={{ 
//           fontSize: '34px', 
//           fontWeight: 'bold',
//           marginTop: '5px'
//         }}>{totalProducts}</h3>
//       </div>
//     </div>
//   </div>

//   {/* Total Inventory Card */}
//   <div style={{
//     flex: 1,
//     backgroundColor: 'lightpink',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     marginRight: '15px'
//   }}>
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: '15px'
//     }}>
//       <Box size={24} color="#10b981" />
//       <div>
//         <p style={{ color: 'black',fontSize:'24px',fontWeight: 'bold', marginBottom: '5px' }}>Total Inventory</p>
//         <h3 style={{ 
//           fontSize: '34px', 
//           fontWeight: 'bold',
//           marginTop: '5px'
//         }}>{totalInventory}</h3>
//       </div>
//     </div>
//   </div>

//   {/* Average Discount Card */}
//   <div style={{
//     flex: 1,
//     backgroundColor: 'lightblue',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//   }}>
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: '15px'
//     }}>
//       <Percent size={24} color="#8b5cf6" />
//       <div>
//         <p style={{ color: 'black', fontSize:'24px',fontWeight: 'bold',marginBottom: '5px' }}>Avg. Discount</p>
//         <h3 style={{ 
//           fontSize: '34px', 
//           fontWeight: 'bold',
//           marginTop: '5px'
//         }}>{averageDiscount}%</h3>
//       </div>
//     </div>
//   </div>
// </div>
// <br/>

//   {/* Bottom row - Charts */}
// <div style={{
//   display: 'flex',
//   flexDirection: 'row',
//   gap: '24px',
//   justifyContent:'center',
//   width: '100%'
// }}>
//   {/* Size Distribution Chart */}
//   <div style={{
//     flex: 1,
//     backgroundColor: 'white',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//   }}>
//     <h2 style={{
//       fontSize: '20px',
//       fontWeight: 'bold',
//       marginBottom: '16px'
//     }}>Size Distribution</h2>
//     <div style={{ height: '288px' }}>
//       <Pie
//         data={sizeChartData}
//         options={{
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'right',
//               labels: { font: { size: 12 } }
//             }
//           }
//         }}
//       />
//     </div>
//   </div>

//   {/* Price Range Distribution Chart */}
//   <div style={{
//     flex: 1,
//     backgroundColor: 'white',
//     padding: '20px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//   }}>
//     <h2 style={{
//       fontSize: '20px',
//       fontWeight: 'bold',
//       marginBottom: '16px'
//     }}>Price Range Distribution</h2>
//     <div style={{ height: '288px' }}>
//       <Line
//         data={priceChartData}
//         options={{
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//               backgroundColor: 'rgba(0,0,0,0.7)',
//               titleColor: 'white',
//               bodyColor: 'white'
//             }
//           },
//           scales: {
//             y: {
//               beginAtZero: true,
//               title: {
//                 display: true,
//                 text: 'Number of Products'
//               }
//             },
//             x: {
//               title: {
//                 display: true,
//                 text: 'Price Ranges'
//               }
//             }
//           }
//         }}
//       />
//     </div>
//   </div>
// </div>
// </div>
//   );



//   const OrderView = () => {
//     const [fromDate, setFromDate] = useState("");
//     const [toDate, setToDate] = useState("");
//     const [selectedYear, setSelectedYear] = useState("");
//     const [selectedStatuses, setSelectedStatuses] = useState(["shipped"]);
    
//     // Filter logic remains the same
//     const filterOrders = () => {
//       return orders.filter((order) => {
//         const orderDate = new Date(order.createdAt || order.updatedAt);
//         const isWithinDateRange =
//           (!fromDate || new Date(fromDate) <= orderDate) &&
//           (!toDate || new Date(toDate) >= orderDate);
//         const isWithinYear =
//           !selectedYear || orderDate.getFullYear().toString() === selectedYear;
//         const matchesStatus = selectedStatuses.includes(order.deliveryStatus);
//         return isWithinDateRange && isWithinYear && matchesStatus;
//       });
//     };
  
//     const handleCheckboxChange = (status) => {
//       setSelectedStatuses(prev =>
//         prev.includes(status)
//           ? prev.filter(s => s !== status)
//           : [...prev, status]
//       );
//     };
  
//     const filteredData = selectedStatuses.map((status) => {
//       const count = filterOrders().filter((order) => order.deliveryStatus === status).length;
//       return { status, count };
//     });
  
//     // Enhanced graph data with different colors for each status
//     const graphData = {
//       labels: filteredData.map((item) => item.status),
//       datasets: [{
//         label: "Orders by Status",
//         data: filteredData.map((item) => item.count),
//         backgroundColor: [
//           '#4CAF50', // green for shipped
//           '#FFA726', // orange for pending
//           '#2196F3', // blue for delivered
//           '#F44336'  // red for cancelled
//         ],
//         borderWidth: 0,
//         borderRadius: 6,
//         barThickness: 32,
//       }]
//     };
  
//     const containerStyle = {
//       padding: '2rem',
//       maxWidth: '1200px',
//       margin: '0 auto',
//       backgroundColor: '#f8fafc'
//     };
  
//     const cardStyle = {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       padding: '2rem',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
//       border: '1px solid #e2e8f0'
//     };
  
//     const inputStyles = {
//       padding: '0.625rem',
//       border: '1px solid #e2e8f0',
//       borderRadius: '6px',
//       outline: 'none',
//       width: '100%',
//       transition: 'border-color 0.2s, box-shadow 0.2s',
//       fontSize: '0.875rem',
//       ':focus': {
//         borderColor: '#3b82f6',
//         boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
//       }
//     };
  
//     const checkboxStyle = {
//       width: '1.125rem',
//       height: '1.125rem',
//       borderRadius: '4px',
//       cursor: 'pointer',
//       marginRight: '0.5rem',
//       accentColor: '#3b82f6'
//     };
  
//     return (
//       <div style={containerStyle}>
//         <div style={cardStyle}>
//           {/* Header Section */}
//           <div style={{ marginBottom: '2rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '1rem' }}>
//             <h2 style={{
//               fontSize: '1.75rem',
//               fontWeight: '700',
//               color: '#1a1a1a',
//               marginBottom: '0.75rem'
//             }}>Order Statistics</h2>
            
//             <p style={{
//               fontSize: '1rem',
//               color: '#4a5568',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '0.5rem'
//             }}>
//               Total Orders: <span style={{ fontWeight: '600', color: '#2d3748' }}>11</span>
//             </p>
//           </div>
  
//           {/* Status Filter Section */}
//           <div style={{ marginBottom: '2rem' }}>
//             <h3 style={{
//               fontSize: '1.125rem',
//               fontWeight: '600',
//               marginBottom: '1rem',
//               color: '#2d3748'
//             }}>Filter by Delivery Status</h3>
//             <div style={{
//               display: 'flex',
//               flexWrap: 'wrap',
//               gap: '1.25rem',
//               alignItems: 'center',
//               backgroundColor: '#f8fafc',
//               padding: '1rem',
//               borderRadius: '8px'
//             }}>
//               {["shipped", "pending", "delivered", "cancelled"].map((status) => (
//                 <label key={status} style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '0.5rem',
//                   cursor: 'pointer',
//                   padding: '0.5rem',
//                   borderRadius: '6px',
//                   backgroundColor: selectedStatuses.includes(status) ? '#eef2ff' : 'transparent',
//                   transition: 'background-color 0.2s'
//                 }}>
//                   <input
//                     type="checkbox"
//                     value={status}
//                     checked={selectedStatuses.includes(status)}
//                     onChange={() => handleCheckboxChange(status)}
//                     style={checkboxStyle}
//                   />
//                   <span style={{
//                     textTransform: 'capitalize',
//                     color: '#4a5568',
//                     fontWeight: selectedStatuses.includes(status) ? '500' : '400'
//                   }}>{status}</span>
//                 </label>
//               ))}
//             </div>
//           </div>
  
//           {/* Date Range and Year Filter Section */}
//           <div style={{ marginBottom: '2rem' }}>
//             <h3 style={{
//               fontSize: '1.125rem',
//               fontWeight: '600',
//               marginBottom: '1rem',
//               color: '#2d3748'
//             }}>Filter by Date Range & Year</h3>
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//               gap: '1.5rem',
//               backgroundColor: '#f8fafc',
//               padding: '1.5rem',
//               borderRadius: '8px'
//             }}>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <label style={{ fontSize: '0.875rem', color: '#4a5568', fontWeight: '500' }}>From:</label>
//                 <input
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   style={inputStyles}
//                 />
//               </div>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <label style={{ fontSize: '0.875rem', color: '#4a5568', fontWeight: '500' }}>To:</label>
//                 <input
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   style={inputStyles}
//                 />
//               </div>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <label style={{ fontSize: '0.875rem', color: '#4a5568', fontWeight: '500' }}>Year:</label>
//                 <select
//                   value={selectedYear}
//                   onChange={(e) => setSelectedYear(e.target.value)}
//                   style={{ ...inputStyles, minWidth: '120px' }}
//                 >
//                   <option value="">Select Year</option>
//                   <option value="2024">2024</option>
//                   <option value="2025">2025</option>
//                   <option value="2026">2026</option>
//                 </select>
//               </div>
//             </div>
//           </div>
  
//           {/* Chart Section */}
//           <div style={{ 
//             height: '400px',
//             backgroundColor: '#f8fafc',
//             padding: '1.5rem',
//             borderRadius: '8px'
//           }}>
//             {selectedStatuses.length > 0 ? (
//               <Bar
//                 data={graphData}
//                 options={{
//                   responsive: true,
//                   maintainAspectRatio: false,
//                   plugins: {
//                     legend: { position: "top" },
//                     title: { 
//                       display: true, 
//                       text: "Orders by Delivery Status",
//                       font: { size: 16, weight: '600' },
//                       padding: { bottom: 20 }
//                     }
//                   },
//                   scales: {
//                     y: { 
//                       beginAtZero: true,
//                       grid: { display: false },
//                       border: { display: false },
//                       ticks: { padding: 10 }
//                     },
//                     x: {
//                       grid: { display: false },
//                       border: { display: false },
//                       ticks: { padding: 10 }
//                     }
//                   }
//                 }}
//               />
//             ) : (
//               <p style={{
//                 textAlign: 'center',
//                 color: '#718096',
//                 marginTop: '2rem',
//                 fontSize: '0.875rem'
//               }}>
//                 Please select at least one status to see the graph
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };
  

//   return (
//     <div className="p-5 bg-gray-100 min-h-screen">
      
//       <div className="mb-6">
//         {/* <h1 className="text-2xl font-bold text-center mb-1">Dashboard</h1> */}
        
//         <div className="flex justify-center gap-4 mb-4">
//         <label style={{
//   display: 'flex',
//   alignItems: 'center',
//   gap: '8px',
//   fontSize: '16px'  // Increased font size
// }}>
//   <input
//     type="radio"
//     name="dashboardView"
//     value="product"
//     checked={activeView === 'product'}
//     onChange={(e) => setActiveView(e.target.value)}
//     style={{
//       marginRight: '8px'
//     }}
//   />
//   <span>Product Dashboard</span>
// </label>
          
//           <label style={{
//   display: 'flex',



//   alignItems: 'center',
//   gap: '8px',
//   fontSize: '16px'  // Increased font size
// }}>
//             <input
//               type="radio"
//               name="dashboardView"
//               value="order"
//               checked={activeView === 'order'}
//               onChange={(e) => setActiveView(e.target.value)}
//               className="form-radio"
//             />
//             <span>Order Dashboard</span>
//           </label>
//         </div>
//       </div>

//       {activeView === 'product' ? <ProductView /> : <OrderView />}
//     </div>
//   );
// };

// export default Dashboard;


import React, { useState, useEffect } from 'react';
import { BsMenuButtonWideFill } from "react-icons/bs";
  import { Pie, Line,Bar } from 'react-chartjs-2';
  import {
    Chart as ChartJS,
    ArcElement,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Tooltip,
    Legend,
    Title,
  } from 'chart.js';
  import { ShoppingBag, Percent, Box } from 'lucide-react';
  import { TbCategory } from "react-icons/tb";
  import { MdOutlineInventory2 } from "react-icons/md";
  import { MdOutlineDiscount } from "react-icons/md";
  import AdminHome from './AdminHome'
  import { IoCloseSharp } from "react-icons/io5";
  import ProductView from './ProductView';
  import OrderView from './OrderView';
  import { AiOutlineProduct } from "react-icons/ai";
  import { MdOutlineProductionQuantityLimits } from "react-icons/md";
  import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';


const Dashboard = () => { 
  const [activeView, setActiveView] = useState('product');
      
    return (
      <>
            <div className="tf-page-title">
                <div className="container-full">
                    <div className="heading text-center">My admin dashboard</div>
                </div>
            </div>

            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                   
                        <AdminHome/>
                
                        <div className="col-lg-9">
                            
                            <div className="my-account-content account-order">
                              <div className="flex justify-center gap-4 mb-4">
                              <div style={{ fontFamily: 'Arial, sans-serif',display:"flex",gap:"5px" }}>
  <label style={{
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '18px',
    cursor: 'pointer',
    marginBottom: '16px',
    border: '1px solid #ddd',
    borderRadius: '1px',
    padding: '10px 16px',
    transition: 'background-color 0.3s, border-color 0.3s'
  }}
    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#faca87'}
    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
  >
    <input
      type="radio"
      name="dashboardView"
      value="product"
      checked={activeView === 'product'}
      onChange={(e) => setActiveView(e.target.value)}
      style={{
        
        width: '20px',
        height: '20px',
        border: '2px solid #888',
        borderRadius: '50%',
        outline: 'none',
        cursor: 'pointer',
        display: 'inline-block',
        position: 'relative'
      }}
    />
  
    <span>Product Dashboard <AiOutlineProduct size={24} color='#cc7b0a'/></span>
  </label>

  <label style={{
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '18px',
    cursor: 'pointer',
    marginBottom: '16px',
    border: '1px solid #ddd',
    borderRadius: '1px',
    padding: '10px 16px',
    transition: 'background-color 0.3s, border-color 0.3s'
  }}
    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#def8ff'}
    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
  >
    <input
      type="radio"
      name="dashboardView"
      value="order"
      checked={activeView === 'order'}
      onChange={(e) => setActiveView(e.target.value)}
      style={{
        
        width: '20px',
        height: '20px',
        border: '2px solid #888',
        borderRadius: '50%',
        outline: 'none',
        cursor: 'pointer',
        display: 'inline-block',
        position: 'relative'
      }}
    />
    <span style={{
      display: 'inline-block',
      position: 'absolute',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: activeView === 'order' ? '#2196f3' : 'transparent',
      top: '4px',
      left: '4px',
      transition: 'background-color 0.3s'
    }}></span>
    <span>Order Dashboard <MdOutlineProductionQuantityLimits size={24} color='#1ec8f7'/></span>
  </label>
</div>

                                            

                                      {activeView === 'product' ? <ProductView /> : <OrderView />}
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="btn-sidebar-account">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                    <BsMenuButtonWideFill />
                </button>
            </div>

            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                        {/* <SideNavbaBarDashboard /> */}
                        <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                    </header>
                    
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;